/// <reference types="vite/client" />

import { ZoomConfig } from './types';
import { FLAVOR } from '../../Config/firebase';

// Zoom Configuration
export const ZOOM_CONFIG: ZoomConfig = {
    clientId: FLAVOR === 'DEVELOPMENT' ? '6JC9jdr7TTmRrbJiY36LGQ' : 'yWe5LBq9SYxBsDHwaRp3A',
    clientSecret: FLAVOR === 'DEVELOPMENT' ? 'ddx3Fcwmt3U2w8EePrE7RMGvXdrODy4Y' : 'peibZ75tbEdPqoA6wfU968K2E2YF48af',
    redirectUri: FLAVOR === 'DEVELOPMENT' ? 'https://api.eaglexlabs.com/api/zoom/zoomCallback' : 'https://besaksham.com/api/zoom/zoomCallback',
    apiEndpoint: 'https://api.zoom.us/v2'
};

// Zoom API endpoints
export const ZOOM_ENDPOINTS = {
    // OAuth endpoints
    authorize: 'https://zoom.us/oauth/authorize',
    token: 'https://zoom.us/oauth/token',
    
    // Meeting endpoints
    createMeeting: '/users/me/meetings',
    getMeeting: (meetingId: string) => `/meetings/${meetingId}`,
    updateMeeting: (meetingId: string) => `/meetings/${meetingId}`,
    deleteMeeting: (meetingId: string) => `/meetings/${meetingId}`,
    listRecordings: (meetingId: string) => `/meetings/${meetingId}/recordings`,
    
    // User endpoints
    getUser: '/users/me',
}; 

/**
 * Generates the Zoom OAuth authorization URL
 * @param state Optional state parameter for OAuth flow
 * @returns The complete authorization URL
 */
export const getZoomAuthUrl = (state?: string): string => {
    // Log environment variables
    console.log('Zoom Config:', {
        redirectUri: ZOOM_CONFIG.redirectUri,
        clientId: ZOOM_CONFIG.clientId,
        envRedirectUri: ZOOM_CONFIG.redirectUri
    });
    // const scope = [
    //     'meeting:write:meeting',
    //     'user:read:user',
    //     'user:read:zak',
    //     'zoomapp:inmeeting'
    //   ].join(' ');
    // Direct construction of the URL to match the expected format
    const baseUrl = 'https://zoom.us/oauth/authorize';
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: ZOOM_CONFIG.clientId,
        redirect_uri: ZOOM_CONFIG.redirectUri,
    });

    if (state) {
        params.append('state', state);
    }

    const finalUrl = `${baseUrl}?${params.toString()}`;
    console.log('Generated Zoom OAuth URL:', {
        url: finalUrl,
        params: Object.fromEntries(params.entries()),
        redirectUri: ZOOM_CONFIG.redirectUri
        });
    return finalUrl;
}; 